<template>
  <div class="my-2">
    <div role="tablist">
      <b-card no-body class="mb-1" v-for="component in components" :key="component.id" style="border:none;">
        <b-card-header :id="component.titleId" class="p-0" role="tab" style="border-bottom:none;">
            <b-button href="#" squared block variant="link" class="kub-btn-white text-decoration-none d-flex" v-b-toggle="component.toggle" :disabled="![formComplete, materialComplete, randComplete][component.id-1]" @click="changeStep(component)">
              <b-iconstack font-scale="1" class="mr-2 align-self-end">
                <b-icon stacked icon="check2" scale="1" v-show="![formComplete, materialComplete, randComplete][component.id-1]" style="color:#ddd;"></b-icon>
                <b-icon stacked icon="check2" scale="1" v-show="[formComplete, materialComplete, randComplete][component.id-1]"></b-icon>
              </b-iconstack>
              <h3 class="font-weight-normal m-0 text-left when-open">{{component.title}}</h3>
              <b-icon icon="pencil" v-b-tooltip.hover title="Bearbeiten" scale="0.75" class="align-self-center ml-auto" v-if="[formComplete, materialComplete, randComplete][component.id-1]"></b-icon>
            </b-button>
        </b-card-header>
        <b-collapse :id="component.toggle" :visible="component.visible" accordion="kub-setup-accordion" role="tabpanel">
            <b-card-body class="p-0 pt-3 pb-3">
              <b-card-text>
                <component :is="component.comp"></component>
              </b-card-text>
            </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import Data from '../../../../data/main/config/setup/setup'

import Form from './form/Form.vue'
import Material from './material/Material.vue'
import Rand from './rand/Rand.vue'

import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      components: Data.components
    }
  },
  methods: {
    ...mapActions([
      'changeStatusForm',
      'changeStatusMaterial',
      'changeStatusRand'
    ]),
    changeStep (comp) {
      switch (comp.id) {
        case 1:
          this.changeStatusForm()
          if (this.materialComplete) {
            this.changeStatusMaterial()
          }
          if (this.randComplete) {
            this.changeStatusRand()
          }
          this.$root.$emit('bv::toggle::collapse', comp.toggle)
          break
        case 2:
          this.changeStatusMaterial()
          if (this.randComplete) {
            this.changeStatusRand()
          }
          this.$root.$emit('bv::toggle::collapse', comp.toggle)
          break
        case 3:
          this.changeStatusRand()
          this.$root.$emit('bv::toggle::collapse', comp.toggle)
          break
      }
    }
  },
  components: {
    appForm: Form,
    appMaterial: Material,
    appRand: Rand
  },
  computed: {
    ...mapGetters([
      'lg',
      'formComplete',
      'materialComplete',
      'randComplete'
    ])
  }
}
</script>

<style scoped>
:not(.collapsed) > .when-open {
  color: #002b36 !important;
  font-weight: 500 !important;
}

</style>
